import { combineReducers } from "redux";
import { LOGINREDUCER } from "./reducers/LoginReducer";
import { TERMINALREDUCER } from "./reducers/TerminalReducer";
import { PROCESSORTERMINALREDUCER } from "./reducers/ProcessorTerminalReducer";
import { ISOREDUCER } from "./reducers/IsoReducer";
import { MERCHANTREDUCER } from "./reducers/MerchantReducer";
import { TRANSACTIONREDUCER } from "./reducers/TransactionReducer";
import { DROPDOWNREDUCER } from './reducers/DropdownReducer';
import { USERSREDUCER } from './reducers/UserReducer';
import { SNACKBARREDUCER } from './reducers/SnackbarReducer';
import { UPLOADREDUCER } from "./reducers/UploadReducer";
import { EXPORTREDUCER } from './reducers/ExportReducers';
import { PROCESSORCONNECTIONREDUCER } from './reducers/ProcessorConnectionReducer';
import { PROCESSORGROUPSREDUCER } from "./reducers/ProcessingGroupReducer";
import { DISPUTEREDUCER } from "./reducers/DisputeReducer";
import { POSCLIENTREDUCER } from "./reducers/POSClientReducer";
import { REGISTERREDUCER } from "./reducers/RegisterReducer";

const appReducer = combineReducers({
  LOGINREDUCER,
  TERMINALREDUCER,
  PROCESSORTERMINALREDUCER,
  ISOREDUCER,
  MERCHANTREDUCER,
  TRANSACTIONREDUCER,
  DROPDOWNREDUCER,
  USERSREDUCER,
  SNACKBARREDUCER,
  UPLOADREDUCER,
  EXPORTREDUCER,
  PROCESSORCONNECTIONREDUCER,
  PROCESSORGROUPSREDUCER,
  DISPUTEREDUCER,
  POSCLIENTREDUCER,
  REGISTERREDUCER,
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT_SUCCESS") {
    return appReducer(undefined, action)
  }
  return appReducer(state, action);
}

export default rootReducer;